<div class="holder">
    <h1>Bizden Haberler</h1>

    <div class="blog-list">
        <article class="blog-post" *ngFor="let post of posts">
            <div class="blog-post__media">
                <img
                    [src]="post.image"
                    [alt]="post.title"
                    (error)="onImageError($event)"
                    loading="lazy"
                />
            </div>
            <div class="blog-post__content">
                <time class="blog-post__date" [attr.datetime]="post.date">{{ post.displayDate }}</time>
                <h2 class="blog-post__title">{{ post.title }}</h2>
                <p *ngFor="let paragraph of post.paragraphs">{{ paragraph }}</p>
                <a
                    *ngIf="post.link"
                    class="blog-post__link"
                    [href]="post.link.url"
                    target="_blank"
                    rel="noopener"
                >{{ post.link.label }}</a>
            </div>
        </article>
    </div>
</div>
